const rawApiUrl = (process.env.REACT_APP_BACKEND_URL || '').trim();

const normalizeApiUrl = (value) => {
  if (!value) return '';

  const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;

  try {
    const parsed = new URL(withProtocol);
    return parsed.origin.replace(/\/+$/, '');
  } catch (error) {
    if (typeof window !== 'undefined') {
      console.error('Invalid REACT_APP_BACKEND_URL:', value);
    }
    return '';
  }
};

export const API_URL = normalizeApiUrl(rawApiUrl);
